import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonusImage, bonuses } from '../data/content';
export function Bonuses() {
  return <section id="bonos" className="w-full bg-cream-100 py-16 lg:py-24" data-id="element-12" data-mp="pjg6i3dq9c1z">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-13" data-mp="avuzvzhn8upb">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start lg:gap-16" data-id="element-14" data-mp="at8ua5ebcp9q">
          <div data-id="element-15" data-mp="fs3bj2wmu5rq">
            <p className="flex items-center gap-2 font-display text-sm font-bold text-gold-600" data-id="element-16" data-mp="1uete2ty9cqd">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-17" data-mp="5w0do98tctal" />
              Incluido sin costo
            </p>
            <h2 className="display-tight mt-4 font-display text-4xl font-extrabold text-forest-800 sm:text-5xl" data-id="element-18" data-mp="3o1v8io5p48td">
              Los 6 bonos de regalo.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-forest-700/80" data-id="element-19" data-mp="3t2socu38gqrp">
              Son las herramientas que hacen el trabajo sucio por vos: planillas
              que calculan solas, checklists y calendarios. Vienen incluidos en
              la compra de hoy.
            </p>
            <img src={bonusImage} alt="Los 6 bonos incluidos: reto de 30 días, planillas 4 bolsillos, calendario de gastos previsibles, kit para salir de deudas, calculadora de fondo de emergencia y planner financiero de 12 meses" className="mt-8 w-full rounded-2xl object-cover shadow-card" data-id="element-20" data-mp="3iclmzqn9ggxa" />
          </div>

          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-21" data-mp="2zesl8rodid1h">
            {bonuses.map((bonus, i) => <li key={bonus.title} className="flex h-full flex-col rounded-xl border border-cream-300 bg-cream-50 p-5" data-id="element-22" data-mp="2uh96lqnrjy90" data-mpi={i}>
                <span className="font-display text-[11px] font-bold uppercase tracking-[0.12em] text-gold-600" data-id="element-23" data-mp="33h5pfbnh22w5">
                  Bono {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-2 font-display text-lg font-bold leading-snug text-forest-800" data-id="element-24" data-mp="nrukynbue34n">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-forest-700/80" data-id="element-25" data-mp="3chv6rum3zkor">
                  {bonus.copy}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}